import styled, { css } from 'styled-components';

import type { ProductTypeOptions } from '@/types/product';

import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Flex)<{
  $isClickable: boolean;
  $nbBuckles: number;
  $productType: ProductTypeOptions;
  $selected: boolean;
}>`
  align-items: center;

  ${({ $isClickable, $nbBuckles, $productType, $selected, theme }) => css`
    margin-bottom: ${theme.spacing(1)};
    transition: ${theme.transitions.duration.standard} ease;

    ${$productType === 'buckle' && $nbBuckles > 1
      ? css`
          max-width: 94px;
          flex-direction: column;
          .image-wrapper {
            box-sizing: border-box;
            padding: ${theme.spacing(1)};
            outline: 1px solid ${theme.colors.quinaryGrey};
            outline-offset: -1px;
          }
          ${$isClickable &&
          css`
            &:hover {
              @media (hover: hover) {
                cursor: pointer;
                .image-wrapper {
                  outline: 3px solid
                    ${$selected
                      ? theme.colors.primaryBlue
                      : theme.colors.primary};
                  outline-offset: -3px;
                }
              }
            }
            &:focus,
            &:focus-visible {
              outline: none;
              .image-wrapper {
                outline: 3px solid
                  ${$selected ? theme.colors.primaryBlue : theme.colors.primary};
                outline-offset: -3px;
              }
            }
          `}

          ${$selected &&
          css`
            .image-wrapper {
              outline: 3px solid ${theme.colors.primaryBlue};
              outline-offset: -3px;
            }
          `}
        `
      : css`
          padding: ${theme.spacing(1)};
          outline: 1px solid ${theme.colors.quinaryGrey};
          outline-offset: -1px;
          ${$isClickable &&
          css`
            &:hover {
              @media (hover: hover) {
                outline: 3px solid
                  ${$selected ? theme.colors.primaryBlue : theme.colors.primary};
                outline-offset: -3px;
                cursor: pointer;
              }
            }
            &:focus,
            &:focus-visible {
              outline: 3px solid
                ${$selected ? theme.colors.primaryBlue : theme.colors.primary};
              outline-offset: -3px;
            }
          `}

          ${$selected &&
          css`
            outline: 3px solid ${theme.colors.primaryBlue};
            outline-offset: -3px;
          `}
        `}
  `}

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ImageWrapper = styled(Flex)<{
  $productType: ProductTypeOptions;
}>`
  position: relative;
  min-width: 88px;
  max-width: 88px;
  height: 88px;
  ${({ $productType, theme }) => css`
    margin-right: ${theme.spacing(2)};

    ${$productType === 'buckle' &&
    css`
      margin-right: 0 !important;
      transition: ${theme.transitions.duration.standard} ease;
    `}
  `};
`;

export const ProductImage = styled(NextImage)<{
  $productType: ProductTypeOptions;
}>`
  object-fit: contain;
  inset: 0;

  ${({ $productType, theme }) => css`
    ${$productType === 'buckle' &&
    css`
      padding: ${theme.spacing(0.5)};
    `}
  `}
`;

export const BuckleName = styled(Typography)`
  @supports (-webkit-line-clamp: 3) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`;

export const InfoBadgeWrapper = styled(Flex)`
  align-items: center;
  gap: 5px;
`;
